import React from "react";
import bloglist from "../../editable-stuff/blog";
import { useParams } from "react-router-dom";

const BlogPost = () => {
  const { id } = useParams();
  const idx = parseInt(id, 10);
  const post = bloglist[idx];

  return (
    <div className="blog-page">
      {post && (
        <>
          {/* TOP: full-width meta + title + subtitle and hero image */}
          <header className="blog-top-hero">
            <div className="blog-top-meta">
              <div className="blog-meta-row">
                <small className="text-muted">
                  {post.published || ""}
                  {post.readTime ? (
                    <>
                      {"  —  "}
                      <span className="read-time">{post.readTime}</span>
                    </>
                  ) : null}
                </small>
              </div>

              <h1 className="blog-title">{post.title}</h1>
              {post.description && <p className="blog-subtitle">{post.description}</p>}
            </div>

            <div className="blog-hero-image-wrap full-width mt-3" aria-hidden={!post.image}>
              {post.image ? (
                <img className="blog-hero-image img-fluid rounded" src={post.image} alt={post.title} />
              ) : (
                <div className="blog-hero-image placeholder">Image placeholder — add a hero image</div>
              )}
            </div>
          </header>

          {/* BELOW: two-column layout - author on left, article on right */}
          <div className="container-lg mt-4">
            <div className="row">
              {/* LEFT: Author sidebar on md+ screens */}
              <aside className="col-md-3 d-none d-md-block">
                <div className="blog-author p-3">
                  <div className="text-muted small">WRITTEN BY</div>
                  <div className="d-flex align-items-center mt-2">
                    {post.author && post.author.logo ? (
                      <img
                        src={post.author.logo}
                        alt={post.author.name}
                        className="author-logo rounded-circle me-3"
                      />
                    ) : (
                      <div className="author-logo-placeholder rounded-circle me-3" />
                    )}
                    <div>
                      <div className="h6 mb-0">{post.author ? post.author.name : ""}</div>
                      <div className="text-muted small">{post.author ? post.author.designation : ""}</div>
                      <div className="small" style={{ color: 'green' }}><strong>{post.author ? post.author.company : ""}</strong></div>

                    </div>
                  </div>

                  {/* Optional share area similar to reference */}
                  <div className="share-area mt-4">
                    <div className="text-muted small">SHARE THIS</div>
                    <div className="d-flex gap-2 mt-2">
                      <button className="btn btn-outline-secondary btn-sm">Copy link</button>
                      <button className="btn btn-outline-secondary btn-sm">X</button>
                      <button className="btn btn-outline-secondary btn-sm">f</button>
                      <button className="btn btn-outline-secondary btn-sm">in</button>
                    </div>
                  </div>

                  {/* You can add related cards or CTA below exactly like ref */}
                </div>
              </aside>

              {/* RIGHT: article area */}
              <main className="col-12 col-md-9">
                {/* Article content rendered by BlogBuilder (now returns fragment only) */}
                <article className="blog-content mt-4">{post.getBlog ? post.getBlog() : null}</article>
              </main>
            </div>
          </div>
        </>
      )}
      {!post && <h1 className="display-1 text-center">404 - Page not found</h1>}
    </div>
  );
};

export default BlogPost;
